import React from "react";
import { DoubleNoteIcon } from "../../../../../utils/svg";

const NotesOption = ({ values = {}, setValues = () => {} }) => {
  return (
    <div
      className={`px-4 mt-4 border-b-8 border-solid pb-4 border-gray-100 ${values?.orderType !== "delivery" ? "hidden" : ""}`}
    >
      <div className="flex items-center text-center">
        <DoubleNoteIcon />
        <div className="text-xs text-gray-900 font-semibold pl-2">
          Catatan Pengiriman
        </div>
        <div className="text-xs text-gray-400 font-thin pl-2">Opsional</div>
      </div>
      <textarea
        id="summary_delivery_note"
        className="mt-2 py-2.5 px-4 text-xs placeholder:text-xs placeholder:text-gray-400 border-1 border-solid border-gray-300 bg-white h-auto"
        defaultValue={values?.notes ?? ""}
        onChange={(e) => {
          setValues((prev) => {
            return {
              ...prev,
              notes: e.target.value ?? ""
            };
          });
        }}
        placeholder="cth: Tolong letakkan makanan di depan pintu"
      />
    </div>
  );
};

export default NotesOption;
